/* The second card image on touch devices.

   Desktop uses :hover and never runs any of this — the guard below returns immediately
   on a machine with a real pointer.

   Touch has no hover, so nothing pretends to be one. The card reveals its second image
   while it crosses the middle band of the viewport and returns to the lead as it leaves.
   The band is deliberately wide (-15% top and bottom, so ~70% of the screen): a narrow
   band swaps each card twice in quick succession, and with one-up cards on mobile that
   leaves something mid-fade at all times. Wide band plus the 0.9s fade in collection.css
   means a card changes once on the way in and holds it.

   Pairs with .card__img--dual / .card--peek in collection.css. */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: none)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      entry.target.classList.toggle('card--peek', entry.isIntersecting);
    });
  }, { rootMargin: '-15% 0px -15% 0px', threshold: 0 });

  function bind() {
    document.querySelectorAll('.card:not([data-peek-bound])').forEach(function (card) {
      if (!card.querySelector('.card__img--dual')) return;
      card.setAttribute('data-peek-bound', '');
      observer.observe(card);
    });
  }

  bind();
  // Sections are replaced wholesale in the theme editor, and search re-renders its grid.
  document.addEventListener('shopify:section:load', bind);
})();
